import styled from "@emotion/styled";

const Styles = styled.div`
  .ant-row {
    display: flex;
  }
`;
export default Styles;
